<template>
  <InterfaceCard
      icon="mdi-bell"
      title="Уведомления"
  >
    <Paginator
        empty-info="Список уведомлений пуст"
        :data="events"
        :endpoint="endpoint"
        @load="onLoad"
    >
      <v-list :dense="$vuetify.breakpoint.mobile" three-line>
        <div
            v-for="event in events"
            :key="event.id"
        >
          <EventListItem :item="event"></EventListItem>
        </div>
      </v-list>
    </Paginator>
  </InterfaceCard>
</template>

<script>
import EventListItem from '@/components/EventListItem'
import InterfaceCard from '@/components/InterfaceCard'
import Paginator from '@/components/Paginator'
import {getSourceId} from '@/composables/context'

export default {
  name: 'EventList',
  components: {EventListItem, InterfaceCard, Paginator},
  data () {
    return {
      endpoint: `${this.$API.EVENTS.LIST}?sourceId=${getSourceId()}`,
      events: [],
    }
  },
  methods: {
    onLoad (data) {
      this.events = this.events.concat(data.items)
    }
  }
}
</script>

<style scoped>

</style>
